import { Component, OnInit, Input, NgZone, SimpleChange, SimpleChanges } from '@angular/core';
import { EnglishLesson } from 'src/app/models/english-lesson';
import { Router, RouterState } from '@angular/router';
import { Translate, getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input() lessons: EnglishLesson[] = []

  mySubscription: any;

  flagImage: string = 'assets/img/us-flag.jpg'

  home: string = 'Home'
  aboutEdu: string = 'About Us'
  profile: string = 'Profile'
  instructor: string = 'Instructor'
  partner: string = 'Partner'
  feedback: string = 'Feedback'
  faq: string = "FAQ's"
  userGuide: string = 'User Guide'
  courses: string = 'Courses'
  englishLesson: string = 'Lessons'
  knowledge: string = 'Knowledge'
  dictionary: string = 'Dictionary'
  contact: string = 'Contact Us'

  pageIndex: number = 0


  constructor(
    private router: Router,
    private zone: NgZone
  ) {
    this.needTranslate()
    router.events.subscribe((val) => {
        this.checkActivePage()
    })
  }

  needTranslate() {
    this.home = getLocalTranslate('home', this.home)
    this.aboutEdu = getLocalTranslate('about-us', this.aboutEdu)
    this.profile = getLocalTranslate('profile', this.profile)
    this.instructor = getLocalTranslate('instructor', this.instructor)
    this.partner = getLocalTranslate('partner', this.partner)
    this.feedback = getLocalTranslate('feedback', this.feedback)
    this.faq = getLocalTranslate('faq', this.faq)
    this.userGuide = getLocalTranslate('user-guide', this.userGuide)
    this.courses = getLocalTranslate('courses', this.courses)
    this.englishLesson = getLocalTranslate('english-lesson', this.englishLesson)
    this.knowledge = getLocalTranslate('knowledge', this.knowledge)
    this.dictionary = getLocalTranslate('dictionary', this.dictionary)
    this.contact = getLocalTranslate('contact-us', this.contact)
  }

  ngOnInit(): void {
    const defaultLanguage = localStorage.getItem('camedu-language')
    this.flagImage = defaultLanguage === 'EN' ? 'assets/img/kh-flag.png' : 'assets/img/us-flag.jpg'

    // this.checkActivePage()

    

  }

  checkActivePage() {

   

    const state: RouterState = this.router.routerState

    var url = state.snapshot.url

   

    if (url === '/') {
      this.pageIndex = 0
    } else if (url.includes('other') || url.includes('instructor') || url.includes('partner')) {
      this.pageIndex = 1
    } else if (url.includes('course')) {
      this.pageIndex = 2
    } else if (url.includes('lesson')) {
      this.pageIndex = 3
    } else if (url.includes('knowledge')) {
      this.pageIndex = 4
    } else if(url.includes('contact')) {
      this.pageIndex = 5
    } else {
      this.pageIndex = 6
    } 

  
  }


  onRouteToCourses(lessonId?: string, levelId?: string) {

    if (levelId === undefined && lessonId === undefined) {
      // All
      this.router.navigate(['lessons'])
        .then(() => {
          window.location.reload()
        });
    } else if (levelId === undefined) {
      // Lessons
      this.router.navigate(['/lessons'], {
        queryParams: { lessonId: lessonId },
        fragment: 'buttonClick'
      })
    } else {
      // Level
      this.router.navigate(['/lessons'], {
        queryParams: { lessonId: lessonId, levelId: levelId },
        fragment: 'buttonClick'
      })
    }
  }

  onSwitchLanguage() {
    const defaultLanguage = localStorage.getItem('camedu-language')
    var currentLanguage: string = ''
    if (!defaultLanguage) {
      currentLanguage = 'EN'
    } else {
      currentLanguage = defaultLanguage === 'EN' ? 'KH' : 'EN'
    }
    console.log(currentLanguage)
    localStorage.setItem('camedu-language', currentLanguage)
    window.location.reload()
  }

  translate(textEn: string, textKh: string): string {
    return Translate(textEn, textKh)
  }

}

